<script>
  import alertify from "alertifyjs";
  import { onMount } from "svelte";
  import Login from "./lib/components/Login.svelte";
  import util from "./js/util";
  import HomePage from "./pages/HomePage.svelte";
  import Menu from "./lib/components/menu/Menu.svelte";
  import PragmaticFreeSpin from "./pages/PragmaticFreeSpin.svelte";
  import NovusCasinoPage from "./pages/FreeBetNovusCasino.svelte";
  import BarbaraBangPage from "./pages/FreeBetBarbaraBang.svelte";
  import EndorphinaPage from "./pages/FreeBetEndorphina.svelte";
  import AnakatechPage from "./pages/FreeBetAnakatech.svelte";
  import FirstPageV2 from "./pages/FreeBetFirstV2.svelte";
  import IgpPage from "./pages/FreeBetIgp.svelte";
  import AmigoGamingPage from "./pages/FreeBetAmigoGaming.svelte";
  import PatePlayFreespins from "./pages/FreespinsPatePaly.svelte";
  import Clients from "./pages/Clients.svelte"
  import Navbar from "./Navbar.svelte";
  import FreeBetAltenar from "./pages/FreeBetAltenar.svelte";

  let authenticated = false;
  let user = {};
  let mainPromise;
  let active_view = "";

  onMount(async () => {
    mainPromise = checkUserIsLogged();
    loadUserFromSession();
  });

  const checkUserIsLogged = async () => {
    return new Promise((resolve, reject) => {
      user = null;
      let now = new Date();
      let userStorage = sessionStorage.getItem("user");
      if (userStorage) {
        userStorage = JSON.parse(userStorage);
        let expireTokenDate = new Date(userStorage.expireToken);
        const diffTime = expireTokenDate - now;
        if (diffTime > 0) {
          user = userStorage;
          authenticated = true;
        } else {
          alertify.warning("ADVERTENCIA su sesión a caducado");
          sessionStorage.removeItem("user");
          authenticated = false;
        }
      }
      resolve(true);
    });
  };

  function onLogin(data) {
    try {
      user = data;
      let token_ = util.parseJwt(user.access_token);
      user.expireToken = new Date(token_.exp * 1000);
      sessionStorage.setItem("user", JSON.stringify(user));
      sessionStorage.setItem("token", user.access_token);
      authenticated = true;
    } catch (error) {
      alertify.error("Error", error);
    }
  }

  class HomeStrategy {
    getComponent() {
      return HomePage;
    }
  }

  class PragmaticStrategy {
    getComponent() {
      return PragmaticFreeSpin;
    }
  }

  class NovusCasinoStrategy {
    getComponent() {
      return NovusCasinoPage;
    }
  }
  class BarbaraBangStrategy {
    getComponent() {
      return BarbaraBangPage;
    }
  }

  class EndorphinaStrategy {
    getComponent() {
      return EndorphinaPage;
    }
  }

  class IgpStrategy {
    getComponent() {
      return IgpPage;
    }
  }

  class AmigoGamingStrategy {
    getComponent() {
      return AmigoGamingPage;
    }
  }
  class PatePlayStrategy {
    getComponent() {
      return PatePlayFreespins;
    }
  }

  class AnakatechStrategy {
    getComponent() {
      return AnakatechPage;
    }
  }

  class FirstStrategyV2 {
    getComponent() {
      return FirstPageV2;
    }
  }

  class ClientsStrategy {
    getComponent() {
      return Clients;
    }
  }

  class AltenarStrategy {
    getComponent() {
      return FreeBetAltenar
    }
  }

  let homeStrategy = new HomeStrategy();
  let anakatechStrategy = new AnakatechStrategy();
  let firstStrategyV2 = new FirstStrategyV2();
  let pragmaticStrategy = new PragmaticStrategy();
  let novusCasinoStrategy = new NovusCasinoStrategy();
  let barbaraBangStrategy = new BarbaraBangStrategy();
  let endorphinaStrategy = new EndorphinaStrategy();
  let igpStrategy = new IgpStrategy();
  let amigoGamingStrategy = new AmigoGamingStrategy();
  let patePlyaStrategy = new PatePlayStrategy();
  let clientsStrategy = new ClientsStrategy();
  let altenarStrategy = new AltenarStrategy();

  let currentStrategy = homeStrategy;
  const onCategoryChange = async (strategy) => {
    console.log("strategy: ", strategy);
    currentStrategy = strategy;
  };
  let isCollapseOpen = false;
  let searchQuery = "";
  let userName = "";

  function loadUserFromSession() {
    const userStr = sessionStorage.getItem("user");
    if (userStr) {
      const userData = JSON.parse(userStr);
      userName = userData.client_code || ""; // o userData.username según respuesta
      authenticated = true;
    }
  }
  function handleLogout() {
    sessionStorage.removeItem("user");
    authenticated = false;
  }

  function handleToggleCollapse() {
    isCollapseOpen = !isCollapseOpen;
  }

  function handleSearch(event) {
    alert("Buscar: " + event.detail.query);
  }

  function handleChangePassword() {
    alert("Cambiar contraseña");
  }
</script>

{#if authenticated}
  <Navbar
    {userName}
    {isCollapseOpen}
    bind:searchQuery
    on:toggleCollapse={handleToggleCollapse}
    on:search={handleSearch}
    on:changePassword={handleChangePassword}
    on:logout={handleLogout}
  />

  <div
    class={`collapse d-md-none ${isCollapseOpen ? "show" : ""}`}
    id="navbarToggleExternalContent"
  >
    <div class="bg-dark p-4 text-white">
      <h5 class="h4">Contenido Colapsado</h5>
      <span class="text-muted">Toggleable via the navbar button.</span>
    </div>
  </div>

  <div class="container mt-3">
    <div class="body-wrapp">
      <Menu
        {onCategoryChange}
        bind:active_view
        {homeStrategy}
        {pragmaticStrategy}
        {novusCasinoStrategy}
        {barbaraBangStrategy}
        {endorphinaStrategy}
        {igpStrategy}
        {amigoGamingStrategy}
        {patePlyaStrategy}
        {anakatechStrategy}
        {altenarStrategy}
        {firstStrategyV2}
        {clientsStrategy}
      />
      <svelte:component this={currentStrategy.getComponent()} />
    </div>
  </div>
{:else}
  <!-- Muestra solo Login si no autenticado -->
  <Login {onLogin} />
{/if}
